import { gql } from "@apollo/client";

export const GET_FEEDBACKS_QUERY = gql`
  query Feedbacks {
    Feedbacks {
      Feedback_ID
      Year_ID
      Vote_ID {
        Vote_ID
        Vote_Code
        Vote_Name
      }
      LG_Vote_ID
      lgVote {
        Vote_ID
        Vote_Code
        Vote_Name
      }
      SEPC_ID
      sepc {
        SEPC_ID
        Parastatal_Code
        Parastatal_Name
      }
      Ticket_No
      Category
      Occurence_Rate
      Impact
      Description
      Image_url
      Assigned_To
      Status
      Resolution_Summary
      Resolution_Type
      Duration
      Assigned_Date
      Created_By
      Modified_By
      Created_Date
      Modified_Date
    }
  }
`;

export const GET_FEEDBACK = gql`
  query getFeedback($id: Int!) {
    Feedback(id: $id) {
      Feedback_ID
      Year_ID
      Vote_ID { Vote_ID Vote_Code Vote_Name }
      LG_Vote_ID
      lgVote { Vote_ID Vote_Code Vote_Name }
      SEPC_ID
      sepc { SEPC_ID Parastatal_Code Parastatal_Name }
      Ticket_No
      Category
      Occurence_Rate
      Impact
      Description
      Image_url
      Assigned_To
      Status
      Resolution_Summary
      Created_By
      Modified_By
      Created_Date
      Modified_Date
    }
  }
`;

export const GET_ACTIVE_FEEDBACKS = gql`
  query activeFeedbacks {
    activeFeedbacks {
      Feedback_ID
      Year_ID
      Vote_ID { Vote_ID Vote_Code Vote_Name }
      lgVote { Vote_ID Vote_Code Vote_Name }
      sepc { SEPC_ID Parastatal_Code Parastatal_Name }
      Ticket_No
      Category
      Occurence_Rate
      Impact
      Description
      Image_url
      Status
      Created_By
      Modified_By
      Created_Date
      Modified_Date
    }
  }
`;

export const GET_FEEDBACK_BY_CLASS = gql`
  query FeedbackByClassID($id: Int!) {
    FeedbackByClassID(id: $id) {
      Feedback_ID
      Year_ID
      Vote_ID { Vote_ID Vote_Code Vote_Name }
      lgVote { Vote_ID Vote_Code Vote_Name }
      sepc { SEPC_ID Parastatal_Code Parastatal_Name }
      Ticket_No
      Category
      Occurence_Rate
      Impact
      Description
      Image_url
      Status
      Created_By
      Modified_By
      Created_Date
      Modified_Date
    }
  }
`;

export const GET_CG_USER_ROLE_ASSIGMENTS = gql`
  query getCgUserRoleAssignments {
    cgUserRoleAssignments {
      Role_Assignment_ID
      User_ID {
        User_ID
        User_Name
        User_Type_ID
        First_Name
        Last_Name
        Email
        Mobile_Number
      }
      Role_ID {
        Role_ID
        Title
      }
      Vote_ID {
        Vote_ID
        Vote_Code
        Vote_Name
      }
      SEPC_ID {
        SEPC_ID
        Parastatal_Code
        Parastatal_Name
      }
      Programme_ID
      Sub_SubProgramme_ID
      Department_ID
      Project_ID
      Status
      Created_By
      Modified_By
      Created_Date
      Modified_Date
    }
  }
`;

export const GET_LG_USER_ROLE_ASSIGMENTS = gql`
  query getLgUserRoleAssignments {
    lgUserRoleAssignments {
      Role_Assignment_ID
      User_ID {
        User_ID
        User_Name
        User_Type_ID
        First_Name
        Last_Name
        Email
        Mobile_Number
      }
      Role_ID {
        Role_ID
        Title
      }
      Vote_ID {
        Vote_ID
        Vote_Code
        Vote_Name
      }
      Sub_SubProgramme_ID
      Service_Area_ID
      LLG_ID
      Status
      Created_By
      Modified_By
      Created_Date
      Modified_Date
    }
  }
`;